package testes

import model.Produto
import utils.ff.Companion.println0

class TestaZuza {

    companion object {

        fun testa() {
            println("Teste zuza")
        }
    }

    fun iniciar() {
        try {
            // 0108076809073028152702011013265584
            //val teste: Map<String, String> = Produto().decodificarCodigoBarras("01080012500027921082024101")
            val teste = Produto().verEan("23")
            println("teste produto 23 " +  teste)



            println0("FIM DO PROCESSO")

        } catch (e: Exception) {
            println0("caiu na exceção " + e.message)
        }
    }
}

fun main() {
    try {
// teste de commit 04/06/18 15:16
        TestaZuza().iniciar()
    } catch (e: Exception) {
        println(e.message)
    }
}